import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b4c18d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-task-preview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoTask = _resolveComponent("InfoTask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InfoTask, {
      highlight: [],
      item: _ctx.task,
      showRefsInline: true,
      showEdit: false,
      onItemClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInfo($event, -1)))
    }, null, 8, ["item"])
  ]))
}